import React from "react";
import { format } from "date-fns";
import { kn } from "date-fns/locale";
import { object, bool } from "prop-types";

import Author from "../../../atoms/author";

import "./author-and-timestamp.m.css";

const AuthorAndTimeStamp = ({ story, isPVExclusive }) => {
  const publishedDateAndTime = format(new Date(story["first-published-at"]), "d MMMM yyyy, H:mm", { locale: kn });
  const lastUpdatedDateAndTime = format(new Date(story["last-published-at"]), "d MMMM yyyy, H:mm", { locale: kn });

  if (isPVExclusive) {
    return (
      <div styleName="pvexclusive">
        <Author authors={story.authors} clazzName="author-name-image" />
        <div styleName="long-line"></div>
        <div styleName="exclusive-timestamp">
          <div styleName="date">Published {publishedDateAndTime} IST</div>
          <div styleName="short-line"></div>
          <div styleName="date">Last Updated {lastUpdatedDateAndTime} IST</div>
        </div>
        <div styleName="long-line"></div>
      </div>
    );
  }

  return (
    <div styleName="wrapper">
      <div styleName="author-name">
        <Author authors={story.authors} clazzName="author-name-image" />
      </div>
      <div styleName="timestamp">
        {story["owner-name"].toLowerCase() !== "migrator" ? (
          <>
            <div styleName="date">Published {publishedDateAndTime} IST</div>
            <div styleName="short-line"></div>
          </>
        ) : null}
        <div styleName="date">Last Updated {lastUpdatedDateAndTime} IST</div>
      </div>
    </div>
  );
};

AuthorAndTimeStamp.propTypes = {
  story: object,
  isPVExclusive: bool,
};

AuthorAndTimeStamp.defaultProps = {
  isPVExclusive: false,
};
export default AuthorAndTimeStamp;
